import { render, staticRenderFns } from "./Tabulator.vue?vue&type=template&id=eed95f58&scoped=true&"
import script from "./Tabulator.vue?vue&type=script&lang=js&"
export * from "./Tabulator.vue?vue&type=script&lang=js&"
import style0 from "./Tabulator.vue?vue&type=style&index=0&id=eed95f58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed95f58",
  null
  
)

export default component.exports